import CollapseCard from 'components/CollapseCard';
import SearchMagnifierIcon from 'images/svg/decorsAndNavigation/SearchMagnifierIcon';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Group, Question } from 'types/FaqQuestions';

interface Props {
  groups: Group[];
  questions: Question[];
}

const SupportFaqQuestions = (props: Props) => {
  const { groups, questions } = props;

  const [searchFilter, setSearchFilter] = useState<string>('');
  const [filteredGroups, setFilteredGroups] = useState<Group[]>(groups);
  const [filteredQuestions, setFilteredQuestions] =
    useState<Question[]>(questions);

  const { t } = useTranslation();

  const onInputChange = e => {
    setSearchFilter(e.target.value);

    const newFilteredQuestions = questions.filter(question =>
      e.target.value
        .split(' ')
        .every(word =>
          question.title
            .concat(question.content)
            .toLowerCase()
            .includes(word.toLowerCase()),
        ),
    );

    const newFilteredGroups = groups.filter(group =>
      newFilteredQuestions.some(question => question.groupId === group.id),
    );

    setFilteredGroups(newFilteredGroups);
    setFilteredQuestions(newFilteredQuestions);
  };

  return (
    <div className="support-faq-questions">
      <form className="support-faq-questions__input-field">
        <SearchMagnifierIcon />
        <input
          className="support-faq-questions__input"
          value={searchFilter}
          placeholder={t('support.faqQuestions.inputPlaceholder')}
          onChange={onInputChange}
        />
      </form>
      <div className="support-faq-questions__groups-wrapper">
        {filteredGroups.length > 0 ? (
          filteredGroups.map(group => (
            <div key={group.id} className="support-faq-questions__groups">
              <h2 className="support-faq-questions__groups-header">
                {group.name}
              </h2>
              <ul>
                {filteredQuestions
                  .filter(question => question.groupId === group.id)
                  .map(groupQuestion => (
                    <li key={groupQuestion.id}>
                      <CollapseCard
                        title={groupQuestion.title}
                        content={groupQuestion.content}
                      />
                    </li>
                  ))}
              </ul>
            </div>
          ))
        ) : (
          <p className="support-faq-questions__groups-no-data">
            {t('support.faqQuestions.noData')}
          </p>
        )}
      </div>
    </div>
  );
};

export default SupportFaqQuestions;
